<div class="row">
    <div class="col-sm-12 nopadding">
        <h2 class="border-btm">DNP/Follow-Up Details <button type="button" (click)="CloseModal()" class="close"></button></h2>

    </div>
    <div class="card" *ngFor="let dnpfollow of leadDnpFollowDetail;">
        <div class="card-body">
          <div class="col-sm-12 nopadding"><strong>{{dnpfollow.statusName}}:</strong> {{dnpfollow.comments}}</div>
          <div class="col-sm-12 nopadding">
            <div class="col-sm-6 nopadding pull-left cardmargintop dnpfontstyle1">
                <span *ngIf="dnpfollow.pagetype==1"><strong>DNP Time:</strong></span>
                <span *ngIf="dnpfollow.pagetype==2"><strong>Follow-Up Time:</strong></span>
                <span *ngIf="dnpfollow.dnp_followup_date">{{dnpfollow.dnp_followup_date*1000|date:'d MMM, yyyy H:m:s'}}</span>
                <span *ngIf="!dnpfollow.dnp_followup_date">-</span></div>
            <div class="col-sm-6 nopadding pull-left cardmargintop dnpfontstyle"><strong>Update Time:</strong> {{dnpfollow.created_at*1000|date:'d MMM, yyyy H:m:s'}}</div>
          </div>

        </div>
    </div>

  </div>
